import { useEffect, useRef, useState } from "react";

interface UseChallengeTimerOpts {
  /** Start / run the timer when true. Stops and resets when false. */
  active: boolean;
  /** Full countdown duration in milliseconds. */
  timeMs: number;
  /** Called exactly once when remainingMs reaches 0. */
  onTimeout: () => void;
}

export function useChallengeTimer(opts: UseChallengeTimerOpts): { remainingMs: number } {
  const [remainingMs, setRemainingMs] = useState(opts.timeMs);
  const startRef = useRef<number | null>(null);
  const onTimeoutRef = useRef(opts.onTimeout);
  onTimeoutRef.current = opts.onTimeout;

  useEffect(() => {
    if (!opts.active) {
      setRemainingMs(opts.timeMs);
      startRef.current = null;
      return;
    }
    startRef.current = Date.now();
    setRemainingMs(opts.timeMs);
    const interval = window.setInterval(() => {
      const elapsed = Date.now() - (startRef.current ?? Date.now());
      const remaining = Math.max(0, opts.timeMs - elapsed);
      setRemainingMs(remaining);
      if (remaining <= 0) {
        window.clearInterval(interval);
        onTimeoutRef.current();
      }
    }, 100);
    return () => window.clearInterval(interval);
  // opts.active and opts.timeMs are the only values that should restart the timer.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opts.active, opts.timeMs]);

  return { remainingMs };
}
